import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Image } from '@components/common';

class PhotoFormatter extends PureComponent {
	render() {
		const { value } = this.props;

		return (
			<div className="flex mobile-max-width">
				<Image
					className="height-50 width-50 border-radius-rounded margin-right-10 img-cover"
					src={value ? value.photo : ''}
					fallbackSrc="avatar"
				/>
				<p className="margin-bottom-0">
					<span className="font-regular display-block color-gray-mine-shaft font-size-15">{ value ? value.name : ''}</span>
					<span className="font-regular display-block color-gray-bayoux font-size-14">{ value ? value.rank : ''}</span>
				</p>
			</div>
		);
	}
}

PhotoFormatter.defaultProps = {
	value : {},
};

PhotoFormatter.propTypes = {
	value : PropTypes.object,
};

export default PhotoFormatter;
